import { Pipe, PipeTransform } from '@angular/core';
import type { Asset } from '../../../models/image/dto/asset';

@Pipe({
  name: 'assetIsImage',
  standalone: false
})
export class AssetIsImagePipe implements PipeTransform {
  transform(asset: Asset): Asset | null {
    return asset?.isImage() ? asset : null;
  }
}
